<div class="oct-modal">
  <h5 class="oc-modal__title">Leave without saving?</h5>
  <mat-dialog-content>
    <p class="oct-modal__text">You have unsaved changes on the page. Are you sure you would like to proceed?</p>
    <p></p
  ></mat-dialog-content>

  <mat-dialog-actions class="oc-modal__buttons">
    <button mat-button type="button" class="oc-modal__button" (click)="closeDialog()">Cancel</button>
    <button mat-flat-button color="warn" class="oc-modal__button" type="submit" (click)="confirm()">Leave without saving</button>
  </mat-dialog-actions>
</div>
